var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content posire"},[_c('qx-line-chart',{ref:"line",attrs:{"allCustomChartObj":_vm.chartObj,"height":"400px","width":_vm.width}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }